"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SideToolBarIconButton = _interopRequireDefault(require("./SideToolBarIconButton"));

var _Constants = _interopRequireDefault(require("./../../Constants"));

var _FaICIconMap = require("./../../FaICIconMap");

require("./../emoji/emojiPlugin.css");

require("./SideToolbar.css");

var _entityData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var entityData = (_entityData = {}, _entityData[_Constants["default"].ENTITY_TYPES.IMAGE] = {
  name: "Image",
  icon: _FaICIconMap.faFileImage
}, _entityData[_Constants["default"].ENTITY_TYPES.BUTTON] = {
  name: "Button",
  icon: _FaICIconMap.faHandPointer
}, _entityData[_Constants["default"].ENTITY_TYPES.SHORT_URL] = {
  name: "Short URL",
  icon: _FaICIconMap.faLink
}, _entityData);

var Toolbar = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Toolbar, _React$PureComponent);

  function Toolbar() {
    return _React$PureComponent.call(this) || this; // this._onScrollWindow = this._onScrollWindow.bind(this);
    // this.state = { isStick: false };
  } // _onScrollWindow() {
  //     this.stop = (this.props.editorRef.current.getBoundingClientRect().top + window.scrollY);
  //     let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  //     if (scrollTop >= this.stop) {
  //         if (!this.state.isStick) {
  //             this.setState({ isStick: true });
  //         }
  //     } else {
  //         if (this.state.isStick) {
  //             this.setState({ isStick: false });
  //         }
  //     }
  // }


  var _proto = Toolbar.prototype;

  _proto.componentDidMount = function componentDidMount() {// setTimeout(() => {
    //     window.addEventListener('scroll', this._onScrollWindow);
    // });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {// window.removeEventListener('scroll', this._onScrollWindow);
  };

  _proto._getEmojiPlugin = function _getEmojiPlugin() {
    if (this.props.plugins.emoji) {
      var _this$props$plugins$e = this.props.plugins.emoji,
          EmojiSuggestions = _this$props$plugins$e.EmojiSuggestions,
          EmojiSelect = _this$props$plugins$e.EmojiSelect;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center card m-2 border-0 shadow"
      }, /*#__PURE__*/_react["default"].createElement(EmojiSelect, null), /*#__PURE__*/_react["default"].createElement(EmojiSuggestions, null));
    }

    return null;
  };

  _proto.render = function render() {
    var enableTools = this.props.enableTools;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.elemRef
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex flex-column justify-content-between mt-2"
    }, this._getEmojiPlugin(), enableTools.map(function (entityType) {
      if (entityType !== _Constants["default"].ENTITY_TYPES.EMOJI) {
        return /*#__PURE__*/_react["default"].createElement(_SideToolBarIconButton["default"], {
          key: entityType,
          name: entityData[entityType].name,
          icon: entityData[entityType].icon,
          entityType: entityType
        });
      }

      return null;
    })));
  };

  return Toolbar;
}(_react["default"].PureComponent);

var _default = Toolbar;
exports["default"] = _default;
module.exports = exports.default;